import AppLayout from "@/app/AppLayout";
import { AsyncBoundary, PageHeader } from "@/ui/patterns";
import { useUserBusiness } from "@/features/settings/hooks/useUserBusiness";
import { NoBusinessYet } from "@/features/settings/components/NoBusinessYet";
import { CodeValidation } from "./components/CodeValidation";

export default function ValidatePage() {
  const { hasBusiness, isLoading, error, refetch } = useUserBusiness();

  return (
    <AppLayout>
      <AsyncBoundary<boolean>
        data={hasBusiness}
        isLoading={isLoading}
        error={error}
        onRetry={refetch}
      >
        {(partnerHasBusiness) =>
          partnerHasBusiness ? (
            <div className="mx-auto max-w-2xl">
              <PageHeader
                title="Ověření kódu"
                description="Zadejte kód rezervace a zaznamenejte příchod zákazníka."
              />
              <CodeValidation />
            </div>
          ) : (
            <NoBusinessYet
              eyebrow="Ověření kódu"
              headline="Kód patří k vašemu podniku."
              body="Ověřujete tu kódy rezervací na termíny, které jste vypsali. Dokud podnik nemáte, nemá kód ke komu patřit a hledání skončí vždycky stejně — nenašli jsme nic."
            />
          )
        }
      </AsyncBoundary>
    </AppLayout>
  );
}
